import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        minDate: String,
    };

    connect() {
        const startDate = this.minDateValue ? new Date(this.minDateValue) : new Date();

        $(this.element).datepicker({
            startDate: startDate,
            endDate: new Date(),
            format: "dd-mm-yyyy",
            startView: 0,
            minViewMode: 0,
            language: document.documentElement.lang.replace("_", "-").split("-")[0],
            disableTouchKeyboard: true,
            orientation: "bottom auto"
        });
    }

    disconnect() {
        $(this.element).datepicker('destroy');
    }
}
